import React from 'react';
import { Typography } from 'antd';
import {
  DashboardOutlined,
  FileTextOutlined,
  CodeOutlined,
  SmileOutlined,
} from '@ant-design/icons';
import '../styles/HomePage.css';

const { Title, Text } = Typography;

const mockRecentItems = [
  { id: '1', name: 'WB Adoption Detailed Dashboard', type: 'dashboard' },
  { id: '2', name: 'SMS Details', type: 'report' },
  { id: '3', name: 'Query Builder Reports Total', type: 'query' },
  { id: '4', name: 'Query Builder Usage Report', type: 'query' },
  { id: '5', name: 'Platformisation Adoption', type: 'dashboard' },
  { id: '6', name: 'Platformisation Adoption', type: 'dashboard' },
];

const HomePage: React.FC = () => {

  const getIconForType = (type: string) => {
    switch (type) {
      case 'dashboard':
        return <DashboardOutlined />;
      case 'report':
        return <FileTextOutlined />;
      case 'query':
        return <CodeOutlined />;
      default:
        return <FileTextOutlined />;
    }
  };

  return (
    <>
      <div className="content-wrapper">
        {/* Greeting Section */}
        <div className="greeting-section">
          <div className="greeting-icon">
            <SmileOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
          </div>
          <Title level={3} style={{ margin: 0, fontWeight: 500 }}>Hi Aman</Title>
        </div>

        {/* Pick up where you left off */}
        <div className="recent-section">
          <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>Pick up where you left off</Text>

          <div className="recent-chips-grid">
            {mockRecentItems.map((item, index) => (
              <div key={`${item.id}-${index}`} className="recent-chip">
                <div className="chip-icon">
                  {getIconForType(item.type)}
                </div>
                <span className="chip-text">{item.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-illustration">
        {/* CSS Art / Background will be handled in CSS */}
      </div>
    </>
  );
};

export default HomePage;
